var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLargeProd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "extraLargeProd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "largeProd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#3f4053"
  }), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(26.5 50.5)",
    fill: "#fff",
    fontSize: 35,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLargeProd);
export default __webpack_public_path__ + "static/media/XLargeProd.8d50bf9897a8a17bdc955116a6034002.svg";
export { ForwardRef as ReactComponent };